<template>
  <div id="app" v-cloak>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html, body, #app{
  padding: 0px;
  margin: 0px;
  height: 100%;
  background: #F7F8FA
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #606266;
}
.editPersonalInfo .el-tabs__nav {
  transform: translateX(60px)!important;
}
.editPersonalInfo .el-tabs__item {
  height: 50px;
  line-height: 50px;
}
.accountSettings .success .el-input__inner {
  border: 1px solid #67C23A;
  border-radius: 4px;
}
.accountSettings .error .el-input__inner {
  border: 1px solid #FA5555;
  border-radius: 4px;
}
.scaleGame .other .el-card__header{
  padding-left: 10px;
}
.scaleGame .has-gutter th{
  font-weight: normal;
}
.scaleEvaluate .el-radio__input{
  display: none;
}
.loginContent .loginType .el-radio__inner{
  display: none!important;
}
.loginContent .el-form-item__content{
  width: 75%;
  margin: 0 auto;
}
.loginContent .el-input__inner{
  border: none!important;
  border-radius: 0%!important;
  border-bottom: 1px solid #C0C4CC!important;
  padding-left: 0px!important;
}
.loginType .el-radio+.el-radio{
  margin-left: 0px;
}
.loginType .el-radio__label{
  padding: 0px;
  color: #909399;
  font-size: 14px;
}
.loginType .el-radio__input.is-checked+.el-radio__label{
  color: #4980FA;
  font-weight: bold;
  font-size: 14px;
}
.el-button--primary.is-plain:focus, .el-button--primary.is-plain:hover{
  background: #709AF7!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue